import { Component, Input, ViewChild, Type, ComponentFactoryResolver } from '@angular/core';
import { CellHolderDirective } from './cell-holder.directive';

@Component({
   selector: 'exi-cell',
   template: `
      <ng-template cell-holder></ng-template>
   `,
   styleUrls: []
})
export class TableCellHolderComponent<D extends object> {
   @ViewChild(CellHolderDirective) private cellHolder: CellHolderDirective;
   @Input() public cell: BodyCell<D>;
   @Input('row') public set rowChanges(row: D) {
      this.createCell(row);
   }

   constructor(
      private cmpResolver: ComponentFactoryResolver
   ) { }

   createCell(row: D) {
      const comp = this.cell.component;
      const factory = this.cmpResolver.resolveComponentFactory(comp);
      const viewRef = this.cellHolder.viewContainerRef;

      // viewRef.clear();

      const instance = viewRef.createComponent(factory).instance;
      instance.value = row;
      instance.cell = this.cell;
   }
}
// ================= Models =================
export class BodyCell<D> {
   constructor( 
      public component: Type<IBodyCell<D>>,
      public stringify: (value: D) => string
   ) {}
}

export interface IBodyCell<D> {
   value: D;
   cell?: BodyCell<D>;
}

